import VAvatarNickname from './index.vue';

export default {
  install: (Vue) => Vue.component('VAvatarNickname', VAvatarNickname),
};
